// import { useState, useContext } from 'react'
// import './signin.css'

// import logo from '../../assets/logo.png'
// import { Link } from 'react-router-dom'
// import { AuthContext } from '../../contexts/auth'


// export default function SignIn(){
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');

//   const { signIn, loadingAuth } = useContext(AuthContext)

//   async function handleSignIn(e){
//     e.preventDefault();

//     if(email !== '' && password !== ''){
//       await signIn(email, password);
//     }

//   }


//   return(
//     <div className="container-center">
//       <div className="login">
//         <div className="login-area">
//           {/* <img src={logo} alt="Logo do sistema" /> */}
//         </div>

//         <form onSubmit={handleSignIn}>
//           <h1>Entrar</h1>
//           <input 
//             type="text" 
//             placeholder="email@email.com"
//             value={email}
//             onChange={ (e) => setEmail(e.target.value) }
//           />

//           <input 
//             type="password" 
//             placeholder="********"
//             value={password}
//             onChange={ (e) => setPassword(e.target.value) }
//           />

//           <button type="submit">
//             {loadingAuth ? "Carregando..." : "Acessar"}
//           </button>
//         </form>

//         {/* <Link to="/register">Criar uma conta</Link> */}

//       </div>
//     </div>
//   )
// }


import { useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../../contexts/auth";
import logo from "../../assets/logo.png";

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { signIn, loadingAuth } = useContext(AuthContext);

  async function handleSignIn(e) {
    e.preventDefault();
    if (email && password) await signIn(email, password);
  }

  return (
<div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#17458f] via-[#f1c04e] to-[#f7a81b] px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-lg overflow-hidden">
        {/* Header com logo */}
        <div className="bg-gray-50 flex flex-col items-center py-8">
          <img
            src={logo}
            alt="Logo Organiza Eventos"
            className="w-24 h-auto drop-shadow-md mb-3"
          />
          <h1 className="text-xl font-semibold text-gray-800">
            Bem-vindo(a) de volta
          </h1>
          <p className="text-sm text-gray-500">
            Acesse sua conta para continuar
          </p>
        </div>

        {/* Formulário */}
        <form
          onSubmit={handleSignIn}
          className="p-8 flex flex-col gap-4"
        >
          <div>
            <label className="text-sm font-medium text-gray-700">E-mail</label>
            <input
              type="email"
              placeholder="exemplo@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
            />
          </div>

          <div>
            <label className="text-sm font-medium text-gray-700">Senha</label>
            <input
              type="password"
              placeholder="********"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition"
            />
          </div>

          <button
            type="submit"
            className="mt-4 bg-blue-600 text-white font-semibold py-2 rounded-lg shadow-md hover:bg-blue-700 hover:shadow-lg transition-all"
          >
            {loadingAuth ? "Entrando..." : "Acessar"}
          </button>

          {/* <p className="text-center text-sm text-gray-600 mt-2">
            Ainda não possui conta?{" "}
            <Link
              to="/register"
              className="text-blue-600 font-medium hover:underline"
            >
              Criar conta
            </Link>
          </p> */}
        </form>
      </div>
    </div>
  );
}
